﻿<template>
	<div v-if="visible" class="ccs-logo-price" :class="status">
		<span v-if="!absent && !loading" class="ccs-logo-price-value">
			{{ value }}
		</span>
		<span v-if="absent" class="ccs-logo-price-fallback" v-html="options.priceFallback"></span>
		<span v-if="loading" class="ccs-logo-price-spinner"></span>
	</div>
</template>

<script>
	export default {
		props: {
			price: Object
		},

		inject: ["options"],

		computed: {
			value() {
				return this.price.value;
			},
			loading() {
				return this.price.loading;
			},
			failed() {
				return this.price.failed;
			},
			absent() {
				return this.options.parsingPriceJs
					? this.failed
					: !this.value
			},
			visible() {
				return !this.absent || this.options.priceFallback;
			},
			status() {
				return {
					"ccs-logo-price_loading": this.loading,
					"ccs-logo-price_absent": this.absent,
				}
			}
		}
	}
</script>

<style scoped>
	.ccs-logo-price-spinner {
		content: "";
		display: block;
		width: 1em;
		height: 1em;
		background-size: 1.4em;
		background-repeat: no-repeat;
		background-position: center;
		background-image: url("img/spinner.svg");
	}

	.ccs-logo-price {
		display: flex;
		align-items: center;
		font-size: 1.7em;
		margin: .3em .6em .3em 0;
		text-align: right;
	}

	.ccs-logo-price > * {
		line-height: 1;
	}
</style>